module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABJklEQVQ4y42SwVWDUBBFLxz3UgKpQDoQd2+ZEtJBKIESYgWhBF3N7MQKxArEDtIBLpzEfxKImXM4wPvvv//fzMumaWKp3H0HjJJ2S5xsScDda+AtfleSxjleznK1wDvwHd+338DdK+ADeAJKYL90iwsBdy+BDkBSHdgIDEBzLnIXXlugAB4C/wQ2CW8NvABf7n5cH4FdZmY98Ag8B+kgabjS2AKogS3wmplZBfShWEs6XGks7l4EvwTqPE6rA+iDcNNmSUMezUpFNv+MtgCqo81TDgLoomFLVQFdOol8htBfERiD8zfGuRPCa5PYaSV1IbCejXJsug+RIQS6GO0+wpRm5cJCGe/tsdOSWkkNsApsm0T9t6ZpOj1m1phZmWJn66WZrVPsB9R8ooEr7SW6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/noStar.png
// module id = VMa5
// module chunks = 1